import $ from 'jquery';
import _ from 'underscore';
import PageApp from 'pageApp';
import { CarouselView, HORIZONTAL } from '@component/product-pool-media';
import RedirectUtil from '@component/common/src/util/RedirectUtil';
import Util from '../util/Util';
import ItemView from './ContentThumbnailView';

module.exports = CarouselView.extend({
  events: _.extend({}, CarouselView.prototype.events, {
    'click .headerText': 'onHeaderClick',
  }),
  initialize(opts) {
    CarouselView.prototype.initialize.apply(this, [opts]);
  },
  getPercentageWidth(contentWidth) {
    let multiplier = 0.68;
    if (contentWidth > 400) {
      multiplier = 0.74;
    } else if (contentWidth > 330) {
      multiplier = 0.715;
    } else if (contentWidth > 300) {
      multiplier = 0.70;
    }
    return multiplier;
  },
  getThumbnailWidth() {
    const contentThumb = this.$el.find('.contentThumb');
    const contentThumbWidth = contentThumb.width();
    return this.getPercentageWidth(contentThumbWidth) * contentThumbWidth;
  },
  setThumbnailWidth() {
    if (Util.isSmallSizeScreen()) { return; }
    if (this.carouselItems && this.carouselItems.length) {
      this.carouselItems.outerWidth(this.getThumbnailWidth());
    }
  },
  setContentGradientCTATop() {
    const that = this;
    const properties = PageApp.getMeta('properties');
    const contentTitle = this.$el.find('.contentTitle');
    const contentTitleCTA = this.$el.find('.contentTitleCTA');
    const contentThumbTop = (properties.isElegantLoading) ? 0 : this.contentThumb.position().top;
    const contentThumbHeight = this.contentThumb.outerHeight();
    const contentThumbWidth = this.contentThumb.outerWidth();
    let contentTitleTextHeight = parseInt(contentTitleCTA.css('line-height'), 10) || 0;
    if (contentTitleTextHeight === 0) {
      const fontSize = contentTitleCTA.css('font-size');
      contentTitleTextHeight = Math.floor(parseInt(fontSize.replace('px', ''), 10) * 1.5);
    }
    const contentTitleCTAMargin = parseInt(contentTitleCTA.css('padding-bottom'), 10) || 0;
    let contentTitleHeight = contentTitleCTA.height();
    contentTitleHeight = (contentTitleTextHeight > 0) ?
      (contentTitleTextHeight + contentTitleCTAMargin) : contentTitleHeight;

    if (contentThumbHeight > 0 && (contentThumbHeight === contentThumbWidth)) {
      contentTitle.css('top', contentThumbTop);
      contentTitle.outerHeight(contentThumbHeight);
      contentTitle.outerWidth(contentThumbWidth);
      contentTitleCTA.css('margin-top', (contentThumbHeight - contentTitleHeight));
    } else {
      setTimeout(() => {
        that.setContentGradientCTATop();
      }, 1000);
    }
  },
  addResizeListener() {
    const that = this;
    $(window).on('resize', _.throttle(() => {
      if (Util.isSmallSizeScreen()) {
        that.carouselItems.width('');
      } else {
        that.carouselItems.outerWidth(that.getThumbnailWidth());
      }
      that.setContentGradientCTATop();
    }, 100));
  },
  buildCarouselOpts(carouselItems) {
    const $adTextForContent = (this.$el.find('.product-pool-media-container .poolHeader .adText'));
    // Adding a class for PROS content specific styling
    $adTextForContent.removeClass('adText').addClass('poolHeaderText poolHeaderTextForContent');
    const headerText = $adTextForContent.text();
    $adTextForContent.empty().html(`<a class="headerText">${headerText}</a>`);
    $('<div class="contentThumb"></div>').insertAfter(this.$el.find('.product-pool-media-container .poolHeader'));

    new ItemView({ el: this.$el.find('.contentThumb'), model: this.model, config: this.options.config }).render();

    // Adding a class specifically to handle situation where KS is ON but rto returns no content (due to an error or being in control)
    $(this.$('.product-pool-media-carousel')[0]).addClass('showContent');
    this.contentThumb = this.$el.find('.contentThumb');
    this.carouselItems = $(carouselItems);
    this.setThumbnailWidth();
    // this.$el.find('.contentTitleCTA').height();
    this.setContentGradientCTATop();
    this.addResizeListener();

    return Object.assign({}, {
      el: this.$('.product-pool-media-carousel')[0],
      childrenView: carouselItems,
      carouselType: HORIZONTAL,
    }, this.options.config, { swatch: false });
  },
  onHeaderClick() {
    const { contentTargetUrl } = this.model.get('content') || {};
    if (contentTargetUrl) {
      RedirectUtil.toHref(contentTargetUrl);
    }
  },
  trimLongProductNames() {},

});
